export { default as DiagnosisCodeListTemplate } from './DiagnosisCodeListTemplate';
export { default as DiagnosisCodeEditTemplate } from './DiagnosisCodeEditTemplate'; 